import React, { useState, useEffect } from "react";
import { TextField, TablePagination, Button } from "@mui/material";
import TopLoader from "../components/Loader/TopLoader";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import pdfUrl from "../docs/fill_checklist.pdf";
import excelURL from "../docs/Dummy_data.xlsx";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import DocumentScannerRoundedIcon from "@mui/icons-material/DocumentScannerRounded";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import { allChecklist, allProgram } from "../api/Users";
import { toast } from "react-toastify";
import AssessmentIcon from '@mui/icons-material/Assessment';

function ProgramMonitoringReport({ userData, role }) {
  const [error, setErrors] = useState({});

  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);

  // Search and pagination
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [loading, setLoading] = useState(0);
  const [Subcastes, setSubCastes] = useState([]);


  useEffect(() => {
    setIsLoading(true);
    let data = {
      gm_id: userData.data.gm_id,
    };
    allProgram(data)
      .then((res) => {
        if (res.status === "success") {
          setFilteredData(res.data.program);
        } else {
          setRows([]);
        }
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
      })
    setIsLoading(false);
  }, []);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  let navigate = useNavigate();

  const view = (rowId) => {
    navigate(`/program-report/${rowId}`);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleImageClick = (imageData) => {
    var w = window.open('about:blank');
    setTimeout(() => {
      w.document.body.appendChild(w.document.createElement('iframe')).src = "data:image/png;base64," + imageData;
      w.document.body.style.margin = 0;
      w.document.getElementsByTagName("iframe")[0].style.width = '100%';
      w.document.getElementsByTagName("iframe")[0].style.height = '100%';
      w.document.getElementsByTagName("iframe")[0].style.border = 0;
    }, 0);
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="row col-12 d-flex justify-content-center mt-4 bg-white">
        {/* <div className="construction"></div> */}
      </div>
      <div className="px-0 px-md-3">
        <div className="mb-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("Program Reports")}</h5>
          <div style={{display: role == 7 ? "none" : "block"}}>
            {/* <button className="btn btn-primary btn-sm" onClick={() => view()}>
              <AddIcon />
              {t("Add Checklist")}
            </button> */}
            
          </div>
        </div>
        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 800 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell align="center">Program Name</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Total Questions</TableCell>
                  <TableCell align="center">Image</TableCell>
                  <TableCell align="center">Posted At</TableCell>
                  <TableCell align="center">Report</TableCell>
                </TableRow>
              </TableHead>
              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">
                          {index + 1}
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          {row.additionalData.name}
                        </TableCell>
                        <TableCell align="center" style={{ width: "10%" }}>
                          {row.additionalData.status === 1 ? "Approved" : "Not Approved"}
                        </TableCell>
                        <TableCell align="center">{row.additionalData.total_questions}</TableCell>
                        <TableCell align="center">
                          {row.image && <img src={`data:image/png;base64,${row.image}`} className="border border-3" alt="Program" style={{ width: "50px", borderRadius: "50%", height: "50px" }} onClick={() => handleImageClick(row.image)} />}
                        </TableCell>
                        <TableCell align="center">{row.additionalData.posted_at}</TableCell>
                        <TableCell align="center">
                          <Tooltip title="Report">
                            <IconButton onClick={() => view(row.additionalData.id)}>
                              <AssessmentIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              )}
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={7}>
                      <h4>
                        <i>No data available</i>
                      </h4>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
}

export default ProgramMonitoringReport;
